import { render, staticRenderFns } from "./AddFrame.vue?vue&type=template&id=638a13af&scoped=true&"
import script from "./AddFrame.vue?vue&type=script&lang=js&"
export * from "./AddFrame.vue?vue&type=script&lang=js&"
import style0 from "./AddFrame.vue?vue&type=style&index=0&id=638a13af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a13af",
  null
  
)

export default component.exports